import { environment } from "../../../environments/environment";

export const PROVIDER_TYPE = "provider_type";
export const REMEMBER_ME = "remember_me";
export type LoginProviders = 'ad' | 'saml' | 'social' | 'custom';

export const getLoginUrl = (requestId: string, providerType: LoginProviders, providerName: string): string => {
    switch(providerType.toLowerCase()) {
      case "ad":
        return environment.base_url + "/ad-srv/ad/login/" + providerName + "/" + requestId;
      case "saml":
        return environment.base_url + "/saml-srv/sp/initiatelogin/"+ providerName + "/login/" + requestId;
      case "social":
      case "custom":
      default:
        return environment.base_url + "/login-srv/social/login/" + providerName + "/" + requestId;
    }
}